import styled from 'styled-components';

export const ParametersStyles = styled.div`
  margin-top: 4px;
  font-size: ${({ theme }) => theme.fontSize.sm};

  // Reset default styles
  table {
    border-spacing: 0 6px;
    border: none;

    tr,
    td {
      padding: 0;
    }
  }

  .second-row,
  .third-row {
    margin-top: 20px;
  }

  .first-item,
  .second-item {
    padding-right: 12px;
  }

  &.desktop {
    .first-row {
      display: none;
    }

    .first-item,
    .third-item {
      width: 150px;
      max-width: 150px;
    }

    .second-item {
      width: 100px;
      max-width: 100px;
    }
  }

  &.laptop {
    .first-item,
    .third-item {
      width: 120px;
      max-width: 120px;
    }

    .second-item {
      width: 90px;
      max-width: 90px;
    }
  }

  &.tablet {
    .first-item,
    .second-item {
      padding-right: 5px;
    }

    .third-row,
    .first-item {
      display: none;
    }

    .second-item,
    .third-item {
      width: 110px;
      max-width: 110px;
    }

    @media screen and (max-width: 539px) {
      .second-item,
      .third-item {
        width: 90px;
        max-width: 90px;
      }
    }
  }

  &.mobile {
    .first-item,
    .second-item {
      padding-right: 5px;
    }

    .first-item,
    .third-item {
      width: 125px;
      max-width: 125px;
    }
    .second-item {
      width: 100px;
      max-width: 100px;
    }

    @media screen and (max-width: 380px) {
      .first-item,
      .second-item,
      .third-item {
        width: 98px;
        max-width: 98px;
      }
    }
  }
`;
